import { ECognitoGroups } from '~/models/auth'

export enum ECapability {
  voipConfig = 'voipConfig',
  voipVoicemails = 'voipVoicemails',
  userManagement = 'userManagement',
  crm = 'crm',
  campaigns = 'campaigns',
  aiAssistantConfig = 'aiAssistantConfig',
  knowledgeBase = 'knowledgeBase',
  reporting = 'reporting',
  orgConfig = 'orgConfig',
}

export enum EAccessLevel {
  read = 'read',
  edit = 'edit',
}

// Internal-admin capabilities (InternalAdminRole), gating `adminLimited`
// Cognito-group users in the admin portal. Separate dimension from
// `ECapability` above, which is org-scoped customer capability access.
export enum EInternalAdminCapability {
  loginAs = 'loginAs',
  createOrgUser = 'createOrgUser',
  manageOrgs = 'manageOrgs',
  manageOrgPlans = 'manageOrgPlans',
  manageMasterData = 'manageMasterData',
  manageAdminUsers = 'manageAdminUsers',
}

export enum EBaseAccess {
  full = 'full',
  custom = 'custom',
}

export enum EEditUserFormFields {
  name = 'name',
  email = 'email',
  status = 'status',
  baseAccess = 'baseAccess',
  capabilities = 'capabilities',
}

export type TEditUserForm = {
  [EEditUserFormFields.name]: string
  [EEditUserFormFields.email]: string
  [EEditUserFormFields.status]: EUserStatus
  [EEditUserFormFields.baseAccess]: EBaseAccess
  [EEditUserFormFields.capabilities]: Partial<
    Record<ECapability, EAccessLevel | ''>
  >
}

export enum EInviteUserFormFields {
  name = 'name',
  email = 'email',
  baseAccess = 'baseAccess',
  capabilities = 'capabilities',
}

export type TInviteUserForm = {
  [EInviteUserFormFields.name]: string
  [EInviteUserFormFields.email]: string
  [EInviteUserFormFields.baseAccess]: EBaseAccess
  [EInviteUserFormFields.capabilities]: Partial<
    Record<ECapability, EAccessLevel | ''>
  >
}

export type TUpdateUserPermissionsPayload = {
  baseAccess: EBaseAccess
  capabilities?: {
    capability: ECapability
    accessLevel: EAccessLevel
  }[]
}

export type TUserPermissionCapability = {
  capability: ECapability
  accessLevel: EAccessLevel
}

export type TUser = {
  adminOwned: boolean
  agentLimit?: number
  cognitoUid?: string
  createdAt: string
  email: string
  id: string
  name?: string
  orgId?: string
  referrer?: string
  unsubscribe: boolean
  updatedAt: string
  groups?: string[]
  lastLogin?: string
  lastSession?: string
  status?: EUserStatus
  paymentTier?: ECognitoGroups
  baseAccess?: EBaseAccess
  capabilities?: TUserPermissionCapability[]
}

export type TUserDetail = TUser & {
  lastSession: string
  paymentTier: ECognitoGroups
  productHistory: {
    id: string
    orgId: string
    trialDuration: number
    tierStartDate: string
  }
}

export type TErrorMutateUserResponse = {
  body: string
  statusCode: number
  headers: object
}

export enum EUserStatus {
  active = 'active',
  disabled = 'disabled',
}

export enum EFriendlyUserStatus {
  active = 'Active',
  disabled = 'Disabled',
  inviteSent = 'Invite Sent',
}

export enum EManageUsersFiltersKeys {
  search = 'search',
}

export type TManageUsersFiltersForm = {
  [EManageUsersFiltersKeys.search]: string
}

export enum EManageUsersTabs {
  active = 'Active',
  disabled = 'Disabled',
}

export enum EUsersTableCellId {
  name = 'name',
  email = 'email',
  groups = 'groups',
  status = 'status',
}
